//App
import useForm from "../../../hooks/useForm";
import {
    CampaignDesignationsReportContextData,
    CampaignDesignationsReportProps
} from "../../../../types/campaignDesignationsReport";
import { CampaignDesignationsReportContext } from "../CampaignDesignationsReportContainer";

const useCampaignDesignationsReport = (props: CampaignDesignationsReportProps) => {
  return useForm<
      CampaignDesignationsReportContextData,
      CampaignDesignationsReportProps
      >(CampaignDesignationsReportContext, props);
};

export default useCampaignDesignationsReport;
